import(/* webpackMode: "eager" */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/app/(alfamall)/error.jsx");
